import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';


class CrispMerchantStatusFilter extends Component {
    state = {
        statusList: [],
        selectedStatuses: [],
        isStatusListLoading: true
    };

    componentDidMount() {
        this.getCrispMerchantStatusList();
    }

    resetCrispMerchantStatusFilter() {
        this.setState({
            selectedStatuses: [],
        });
    }

    getCrispMerchantStatusList() {
        axios.get(config.get('API_URL') + '/filters/get-crisp-merchant-status/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                const statusList = response.data.map(item => ({
                    value: item.status,
                    label: item.status
                }));
                 const selected = (this.props.value || []).map(val => ({
                    value: val,
                    label: val
                }));
                this.setState({
                    statusList,
                    isStatusListLoading: false,
                    selectedStatuses: selected
                });
            }
        });
    }

    changeCrispMerchantStatus(optionSelected) {
        let selectedStatuses = optionSelected.map(item => item.value);

        // Optional: reorder selected to top (if needed)
        optionSelected.forEach((item) => {
            const index = this.state.statusList.findIndex(obj => obj.value === item.value);
            this.state.statusList.move(index, 0).join(',');
        });

        this.props.onSelectCrispMerchantStatus(optionSelected, selectedStatuses);

        this.setState({
            selectedStatuses: optionSelected
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="crisp_merchant_status"
                isMulti
                value={this.state.selectedStatuses}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeCrispMerchantStatus.bind(this)}
                options={this.state.statusList}
                placeholderButtonLabel="Select [Merchant Status]"
                isLoading={this.state.isStatusListLoading}
            />
        );
    }
}

export default CrispMerchantStatusFilter;
